import type { FreelancerAddCertificationDocumentPageLocales } from '../types';

const freelancerAddCertificationDocumentPageLocales: FreelancerAddCertificationDocumentPageLocales =
  {
    certificateAdded: 'Certificaat succesvol geüpload!',
    certificateName: 'Naam certificaat',
    dateInvalid: 'De geselecteerde datum is ongeldig',
    fileRequired: 'Upload een bewijs om het diploma op te slaan.',
    helperMessage:
      'Voeg hieronder je certificaat toe. We hebben daarvoor een naam en bewijs nodig. De geldigheidsdatum is optioneel.',
    ifApplicable: '(indien van toepassing)',
    noDataMessage:
      'Er is iets fout gegaan! De benodigde bronnen voor deze pagina zijn niet beschikbaar.',
    noResultFound: 'geen resultaten gevonden',
    saveCertificate: 'Certificaat opslaan',
    selectDocType: 'Geen Certificaat geselecteerd.',
    title: 'Certificaat toevoegen',
    uploadProof: 'Upload bewijs',
    validUntil: 'Geldig tot ',
    validUntilRequired: 'Voor dit document is een geldigheidsdatum verplicht',
    wrongFileExtension:
      'Document heeft niet de juiste extensie. Upload een PDF bestand of foto.',
  };

export default freelancerAddCertificationDocumentPageLocales;
